import { axiosObject } from "../config";

export default function bulkFileOwnerServicechange(payload: any) {
  return new Promise((resolve, reject) => {
    let uri =
      process.env.NEXT_PUBLIC_APP_NAME === "admin"
        ? `/bulk-files-owner-service-change`
        : `/auction/bulk-files-owner-service-change`;

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response?.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
